import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';

// Reusable base for ABP conventional-controller CRUD services, so each feature's
// service isn't a near-duplicate. Routes follow ABP's mapping for a controller
// at `basePath`:
//   GetListForDataTableAsync -> GET    {base}/for-data-table
//   CreateAsync(input)       -> POST   {base}
//   UpdateAsync(id, input)   -> PUT    {base}/{id}
//   DeleteAsync(id)          -> DELETE {base}/{id}
// Spread the result into a service object and add any custom methods alongside.
export function createAbpCrudService<TRow, TCreate, TUpdate, TListInput extends object>(
  basePath: string,
) {
  return {
    basePath,

    async getListForDataTable(input: TListInput): Promise<PagedResult<TRow>> {
      const { data } = await http.get<PagedResult<TRow>>(`${basePath}/for-data-table`, {
        params: input,
      });
      return data;
    },

    async create(input: TCreate): Promise<TRow> {
      const { data } = await http.post<TRow>(basePath, input);
      return data;
    },

    async update(id: string, input: TUpdate): Promise<TRow> {
      const { data } = await http.put<TRow>(`${basePath}/${id}`, input);
      return data;
    },

    async remove(id: string): Promise<void> {
      await http.delete(`${basePath}/${id}`);
    },
  };
}
